// extracted by mini-css-extract-plugin
module.exports = {"item":"item__3PLqu","description":"description__3-mLp"};